import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Box } from '../Box/index.js';

var ProgressCircleValue = function (_a) {
    var label = _a.label, restProps = __rest(_a, ["label"]);
    return (jsxs(Box, __assign({}, restProps, { themeKey: "progressCircleValue" }, { children: [label, jsx("sup", { children: "%" })] })));
};
ProgressCircleValue.displayName = "ProgressCircleValue";

export { ProgressCircleValue };
//# sourceMappingURL=ProgressCircleValue.js.map
